
import './App.css';

import RoutesConfig from './routes/routes_config';


function App() {
  return <div className='bg-slate-200 min-h-screen'><RoutesConfig/></div>
}

export default App;
